import { render, staticRenderFns } from "./BpcPageTop.vue?vue&type=template&id=b876bb88&scoped=true&"
import script from "./BpcPageTop.vue?vue&type=script&lang=js&"
export * from "./BpcPageTop.vue?vue&type=script&lang=js&"
import style0 from "./BpcPageTop.vue?vue&type=style&index=0&id=b876bb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b876bb88",
  null
  
)

export default component.exports